export default "__VITE_ASSET__C2YMRwTd__"